import { render, staticRenderFns } from "./previewPicture.vue?vue&type=template&id=6509e4b6&scoped=true&"
import script from "./previewPicture.vue?vue&type=script&lang=js&"
export * from "./previewPicture.vue?vue&type=script&lang=js&"
import style0 from "./previewPicture.vue?vue&type=style&index=0&id=6509e4b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509e4b6",
  null
  
)

export default component.exports